import { ICON__image_solid } from '@/assets/icons_fa';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { path_relative_to_absolute } from '@/utils/utils_files_client';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { FN_GRID2D_GALLERY__set_cell_current } from './FN_GRID2D_GALLERY__set_cell_current';

interface PROPS {
  grid2d: DTO__grid2d;
  cell: DTO__grid2d_cell;
}

//todo: implement shortcut movement between cells + chunks
export function GRID2D_GALLERY__image_neigbours_row_item({ cell, grid2d }: PROPS) {
  const { global__grid2d_gallery_cell_current } = use_slice_ui(['global__grid2d_gallery_cell_current']);

  const is_current_cell = global__grid2d_gallery_cell_current._id == cell._id;

  /*
   *
   */
  function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    FN_GRID2D_GALLERY__set_cell_current(grid2d, cell);
  }

  /*
   *
   */
  function render_image() {
    if (cell.image.is_stub()) return <ICON__image_solid className="size-5 text-bar-foreground" />;

    return (
      <img
        draggable={false}
        src={url_absolute}
        alt={`${cell.image.image_size.width}x${cell.image.image_size.height}`}
        role="button"
        className=" size-full max-w-full max-h-full object-contain rounded "
      />
    );
  }

  /*
   *
   */
  if (cell.image.is_stub()) return null;

  const url_absolute = path_relative_to_absolute(cell.image.url_relative_latest);

  return (
    <div
      className={`size-10 flex-center
        bg-bar
        rounded 
        border-2
    ${is_current_cell ? ' border-green-500' : 'border-component-border'} 
    `}
      {...{ onClick }}
    >
      {render_image()}
    </div>
  );
}
